import { faStar } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import "./Review_Card.css";
import React from 'react'
import { formatDate } from '../../../utils/common';
import { IDS } from '../../../utils/IDS';

const Review_Card = (props) => {

    return (
        <div className='Review_Card'>
            <div className='top_part'>
                <div className='name_div'>
                    <p>{props?.review?.User?.name || "Unknown User"}</p>
                </div>

                <div className='date'>
                    <p>{formatDate(props?.review?.createdAt)}</p>
                </div>
            </div>

            <div className='footer_part'>
                <div className='review_tab'>
                    <p className='review_text'>{props?.review?.review || " "}</p>
                    <div className='d-flex align-items-center'>
                        <p className='ratep'>{props?.review?.ratings || "0"}</p>

                        <FontAwesomeIcon icon={faStar} className="star_icon" />

                    </div>
                </div>
                {props?.review?.Review_Images?.[0]?.image &&
                    <div className='img_holder'>
                        <img src={IDS.IMG_URL + props?.review?.Review_Images?.[0]?.image} className='product_image' />
                    </div>}
            </div>
        </div>
    )
}

export default Review_Card
